import React from 'react';
import { parseWatchVideoTitle } from './utils';

interface WatchVideoCardProps {
  href: string;
  image?: string;
  title: string;
}

export function WatchVideoCard({ href, image, title }: WatchVideoCardProps) {
  const { cleanedTitle, ticker } = parseWatchVideoTitle(title);

  return (
    <article
      className="group flex min-w-0 flex-col overflow-hidden rounded-xl border border-[#d4e3f7] bg-white shadow-[0_1px_3px_rgba(25,41,64,0.06)] transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-[#a8c4e8] hover:shadow-[0_12px_32px_rgba(25,41,64,0.14)]"
    >
      <a className="block text-inherit no-underline" href={href}>
        <div className="relative aspect-video overflow-hidden bg-[#0f1c2e]">
          {image ? (
            <img
              alt={cleanedTitle}
              className="h-full w-full object-cover transition-transform duration-[350ms] ease-out group-hover:scale-[1.03]"
              loading="lazy"
              src={image}
            />
          ) : null}
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-gradient-to-b from-[rgba(15,28,46,0.08)] from-0% via-[rgba(15,28,46,0.02)] via-45% to-[rgba(15,28,46,0.35)] opacity-55 transition-opacity duration-200 group-hover:opacity-75"
          />
          <div aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div
              className="flex h-11 w-11 items-center justify-center rounded-full bg-[rgba(25,121,255,0.92)] text-white opacity-90 shadow-[0_4px_20px_rgba(25,121,255,0.5)] transition-[opacity,transform,box-shadow] duration-200 group-hover:scale-105 group-hover:opacity-100 group-hover:shadow-[0_6px_28px_rgba(25,121,255,0.6)]"
            >
              <svg className="block h-7 w-7 -translate-x-px" viewBox="0 0 24 24">
                <path d="M9.5 7.25v9.5l8-4.75z" fill="currentColor" />
              </svg>
            </div>
          </div>
          {ticker && (
            <span className="absolute bottom-3 left-3 z-10 rounded bg-[rgba(15,28,46,0.75)] px-2 py-0.5 text-[0.6875rem] font-bold tracking-wide text-white backdrop-blur-sm max-sm:bottom-2 max-sm:left-2">
              ${ticker}
            </span>
          )}
        </div>
      </a>
      <div className="border-t border-[#e8f0fb] bg-gradient-to-b from-[#fafcff] to-white px-4 pb-4 pt-3.5 max-sm:px-3.5 max-sm:pb-3.5 max-sm:pt-3">
        <h3 className="m-0 text-[0.9375rem] font-bold leading-snug text-[#1a2d44] max-sm:text-sm">
          <a className="line-clamp-2 text-inherit no-underline transition-colors hover:text-[#1979ff]" href={href}>
            {cleanedTitle}
          </a>
        </h3>
      </div>
    </article>
  );
}
